/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Guide_Stat_2Inputs */

const en_landing_guide_stat_2 = /** @type {(inputs: Landing_Guide_Stat_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`24.2 MP`)
};

const zh_landing_guide_stat_2 = /** @type {(inputs: Landing_Guide_Stat_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`24.2 MP`)
};

/**
* | output |
* | --- |
* | "24.2 MP" |
*
* @param {Landing_Guide_Stat_2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_guide_stat_2 = /** @type {((inputs?: Landing_Guide_Stat_2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Guide_Stat_2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_guide_stat_2(inputs)
	return zh_landing_guide_stat_2(inputs)
});
export { landing_guide_stat_2 as "landing.guide.stat_2" }